module.exports = __webpack_public_path__ + "img/186-dominica.708c6f55.svg";